
import { Button } from "@/components/ui/button";

interface FormSubmitButtonProps {
  isSubmitting: boolean;
  membershipType: "active" | "benefactor" | "donor";
  donationAmount?: number;
}

export function FormSubmitButton({ 
  isSubmitting, 
  membershipType, 
  donationAmount = 0 
}: FormSubmitButtonProps) {
  console.log("RENDER: FormSubmitButton with membershipType:", membershipType);
  
  const buttonText = membershipType === "donor"
    ? `Faire un don de ${donationAmount}€`
    : "Adhérer";

  return (
    <Button 
      type="submit" 
      className="bg-blue-900 hover:bg-blue-900/90 text-white font-semibold px-10 py-3 rounded-md shadow-sm"
      disabled={isSubmitting}
    >
      {isSubmitting ? "Traitement en cours..." : buttonText}
    </Button>
  );
}
